/**
 * Une coordonnée reçue du temps réel est-elle exploitable pour positionner un
 * marqueur sur la carte ?
 *
 * Module PUR (aucune dépendance) : `socketClient` tire socket.io-client et la
 * config d'environnement, ce qui le rend intestable sans mocks. La règle métier
 * vit donc ici, testée directement.
 *
 * Rejette :
 *  - les non-nombres (null, undefined, chaînes, NaN, Infinity) ;
 *  - les valeurs hors bornes géographiques ;
 *  - le point 0/0 — « Null Island », au large du Ghana. C'est la valeur par
 *    défaut typique d'un GPS sans fix : l'afficher téléporterait la moto à
 *    ~500 km de Cotonou, en plein golfe de Guinée.
 *
 * ⚠️ 0 n'est suspect QU'EN PAIRE : sur l'équateur ou le méridien de Greenwich,
 * une composante nulle est parfaitement légitime.
 */
export function isUsableCoordinate(lat: unknown, lng: unknown): boolean {
  if (typeof lat !== "number" || typeof lng !== "number") return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng))      return false;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180)           return false;
  if (lat === 0 && lng === 0)                              return false;
  return true;
}
